import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { StickyDonateBar } from "./StickyDonateBar";
import { FloatingChat } from "./FloatingChat";
import { Seo } from "@/components/seo/Seo";
import { SeoAudit } from "@/components/seo/SeoAudit";
import { buildOrgJsonLd, buildWebsiteJsonLd } from "@/lib/seo";

// ExitIntentPopup is only triggered after an 8s delay on mouse-out, so there's
// no need for it in the initial bundle. Lazy-loading it reduces TBT/TTI without
// changing user experience.
const ExitIntentPopup = lazy(() =>
  import("./ExitIntentPopup").then((m) => ({ default: m.ExitIntentPopup })),
);

// Default site-wide SEO. Page-level <Seo /> components override these via
// react-helmet-async's last-write-wins behaviour for matching tags.
const SITE_SAME_AS = [
  "https://www.facebook.com/RaiseSriLanka",
  "https://venmo.com/u/Raisesrilanka",
  "https://wa.me/+18574520776",
  "https://www.messenger.com/t/236059781044801",
];

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Seo
        title="Raise Sri Lanka — Bring hope to every Sri Lankan family"
        description="Donate monthly, give once, sponsor a project, or start a fundraiser. A US 501(c)(3) funding education, health, and disaster recovery across Sri Lanka."
        type="website"
        keywords={[
          "Sri Lanka charity",
          "Sri Lanka nonprofit",
          "donate to Sri Lanka",
          "501(c)(3) Sri Lanka",
          "Sri Lanka education",
          "Sri Lanka disaster recovery",
          "monthly donation Sri Lanka",
        ]}
        jsonLd={[
          buildOrgJsonLd({
            sameAs: SITE_SAME_AS,
            email: "contact@raisesrilanka.org",
            phone: "+1-857-452-0776",
          }),
          buildWebsiteJsonLd(),
        ]}
      />
      <Helmet>
        <link rel="alternate" type="application/ld+json" href="/.well-known/ai-manifest.json" />
        <link rel="alternate" type="text/markdown" href="/llms.txt" title="LLM index" />
        <link rel="alternate" type="text/markdown" href="/llms-full.txt" title="LLM full vault" />
      </Helmet>
      <SiteHeader />
      <main className="flex-1 pb-16 md:pb-0">
        <Outlet />
      </main>
      <SiteFooter />
      <StickyDonateBar />
      <FloatingChat />
      <Suspense fallback={null}>
        <ExitIntentPopup />
      </Suspense>
      <SeoAudit />
    </div>
  );
}
